import React, { useEffect, useState } from "react";
import fanbase from "../../../../../assets/images/Fanbase-img/fanBaseApprove/c7mgygu5 1.png";
import fanbase1 from "../../../../../assets/images/Fanbase-img/fanBaseGroup/1.png";
import { DropdownButton, Dropdown } from "react-bootstrap";
import "./ApproveComponent.css";
import DeclineModal from "./DeclineModal";
import axios from "axios";
import { useParams } from "react-router-dom";
import moment from "moment";
import ReactPlayer from "react-player";
import swal from "sweetalert";
import { serverInfo } from "../../../../../App";
import { useContext } from "react";

const ApproveComponent = (props) => {
  const [modalShow, setModalShow] = React.useState(false);
  const [checkApprove, setCheckApprove] = useState(false);
  const [checkDecline, setCheckDecline] = useState(false);
  const { imageCdnUrl,videoCdnUrl } = useContext(serverInfo);

  let { slug } = useParams();

  const [fanPost, setFanPost] = useState([]);

  useEffect(() => {
    axios.get(`/api/admin/fan/group/show/${slug}`).then((res) => {
      if (res.status === 200) {
        setFanPost(res.data.fanPost);
      }
    });
  }, [slug]);

  function approveMember(id) {
    axios.post(`/api/admin/fan/member/post/${id}`).then((res) => {
      if (res.status === 200) {
        setCheckApprove(true);
        props.checkAppRealData(true);

        swal("Welcome", res.data.message, "success");
        // history.push('/superstar-admin/fan-group');
      }
    });
  }

  const declineDataFun = (data, modelData) => {
    setCheckDecline(data);
    props.checkDecRealData(true);
    setModalShow(modelData);
  };

  function handleIdWarning(id, fanId) {
    axios
      .post(`/api/admin/fan/group/approval/warning/${id}/${fanId}`)
      .then((res) => {
        if (res.status === 200) {
          swal("Welcome", res.data.message, "success");
          // history.push('/superstar-admin/fan-group');
        }
      });
  }

  if (checkApprove || checkDecline) {
    axios.get(`/api/admin/fan/group/show/${slug}`).then((res) => {
      if (res.status === 200) {
        setFanPost(res.data.fanPost);
      }
    });
    setCheckDecline(false);
    setCheckApprove(false);
  }

  return (
    <div>
      <div className="container-lg">
        <div className="parent-divFan">
          <div className="child-divFan">
            {fanPost.map((post, i) => (
              <div className="card card-bg postFancard my-4">
                <div className="card-body">
                  <div className="container-lg">
                    <div className="d-flex">
                      <img
                        src={imageCdnUrl + post.user?.image}
                        className="img-fluid mx-2 hasImg"
                        alt=""
                      />

                      <div className=" w-75">
                        <h6 className="m-0">
                          {post.user?.first_name} {post.user?.last_name}
                        </h6>
                        <small style={{ color: "#A7A7A7" }}>
                          <span>{moment(post.created_at).format("LT")} </span>{" "}
                          <span className="mx-2">
                            {moment(post.created_at).format("LL")}
                          </span>{" "}
                          <span>{post.star_name}</span>
                        </small>
                      </div>
                      <div>
                        <div className="starDropdown">
                          <DropdownButton
                            variant="dark"
                            className="bg-dark text-light"
                            id="dropdown-basic-button"
                            title="....."
                          >
                            <Dropdown.Item
                              href="#/action-1"
                              className="text-light"
                              onClick={() =>
                                handleIdWarning(post.user_id, post.fan_group_id)
                              }
                            >
                              <i className="fa-solid fa-triangle-exclamation mx-1"></i>
                              Give Warning
                            </Dropdown.Item>
                          </DropdownButton>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="container my-2">
                    <p className="text-light">{post?.description}</p>
                    {post?.image || post?.video !== null ? (
                      <>
                        {post?.image ? (
                          <img
                            src={imageCdnUrl + post?.image}
                            className="img-fluid w-100"
                            alt=""
                          />
                        ) : (
                          <center>
                            <ReactPlayer
                              url={videoCdnUrl + post?.video}
                              autoplay
                              controls="true"
                            />
                          </center>
                        )}
                      </>
                    ) : (
                      <></>
                    )}

                    <div className="row my-2">
                      <div className="col-6 text-center">
                        <button
                          className="btn approve-btn w-100 text-light py-3"
                          onClick={() => approveMember(post.id)}
                        >
                          <i
                            className="fa fa-check mx-1"
                            aria-hidden="true"
                          ></i>
                          Approve
                        </button>
                      </div>
                      <div className="col-6 text-center">
                        <button
                          className="btn approve-btn2 w-100 text-light py-3"
                          onClick={() => setModalShow(true)}
                        >
                          <i className="fa fa-ban mx-1" aria-hidden="true"></i>
                          Decline
                        </button>
                        <DeclineModal
                          show={modalShow}
                          onHide={() => setModalShow(false)}
                          postId={post.id}
                          declineData={declineDataFun}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApproveComponent;
